//wrap the entire app in the errorBoundary
// using useContext
//storing a state above all DOM so all components can pick it up - like ThemeProvider
//then use this to set an error state that can be referenced by the error boundary to reset it?? - gotta test this last step

import React, { createContext, useContext, useState } from "react";

interface ErrorContextType {
	error: Error | null;
	setError: (error: Error) => void;
	resetError: () => void;
}

interface ErrorContextProps {
	children: React.ReactNode;
}

const ErrorContext = createContext<ErrorContextType | undefined>(undefined);

export const ErrorProvider = (props: ErrorContextProps) => {
	const { children } = props;
	const [error, setError] = useState<Error | null>(null);

	const resetError = () => setError(null);

	return <ErrorContext.Provider value={{ error, setError, resetError }}>{children}</ErrorContext.Provider>;
};

export const useErrorContext = () => {
	const context = useContext(ErrorContext);
	if (!context) {
		throw new Error("useErrorContext must be used within an ErrorProvider");
	}
	return context;
};
